import { useCallback, useEffect, useRef } from 'react'

export type UseDebounceFn<T> = (...args: T[]) => void

function useDebounce<T>(debounceFn: UseDebounceFn<T>, time = 300): UseDebounceFn<T> {
  const timer = useRef<number | null>(null)
  useEffect(
    () => () => {
      if (timer.current) {
        clearTimeout(timer.current)
      }
    },
    [],
  )

  return useCallback(
    (...args: T[]) => {
      if (timer.current) {
        clearTimeout(timer.current)
      }

      timer.current = setTimeout(() => debounceFn(...args), time)
    },
    [debounceFn, time],
  )
}

export default useDebounce
